import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Story } from "../components/Story";
import { Film } from "../components/Film";
import { Wines } from "../components/Wines";
import { Club } from "../components/Club";
import { Events } from "../components/Events";
import { Visit } from "../components/Visit";
import { Footer } from "../components/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="bg-[#0A0908] min-h-screen">
      <Navbar />
      <Hero />
      <Marquee />
      <Story />
      <Film />
      <Wines />
      <Club />
      <Events />
      <Visit />
      <Footer />
    </div>
  );
}
